


















































import { Component, Vue } from "vue-property-decorator";
import Page from "@/components/for-page-grid/Page.vue";
import {getBaseUrl, getOrgInn, getOrgName} from "@/lib/org_info";

@Component({
  components: { Page },
  methods: {getBaseUrl, getOrgInn, getOrgName},
})
class Agreement extends Vue {

}

export default Agreement;
